import { makeStyles } from '@material-ui/core/styles';

export const useViewTemplatePagesStyles = makeStyles(theme => ({
  root: {}
}));
